export { GenericMeetingPanel } from './GenericMeetingPanel';
export * from './interface';
